// MyWalletPDF.jsx
import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';

import websitelogo from "../../../../assets/websitelogo.png";
import websitelogoes from "../../../../assets/websitelogoes.png";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
    color: '#101828',
  },
  logo: {
    width: 120,
    marginBottom: 20,
    alignSelf: "center",
  },
  heading: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 20,
    color: '#003149',
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  label: {
    color: '#344054',
    fontWeight: 'bold',
  },
  value: {
    color: '#101828',
  },
});

const MyWalletPDF = ({ data }) => {
  const { t, i18n } = useTranslation();

  const logoToUse = i18n.language === "es" ? websitelogo : websitelogoes;

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* Dynamic Logo */}
        <Image src={logoToUse} style={styles.logo} />

        {/* Dynamic Title */}
        <Text style={styles.heading}>   {t("managePayout.heading")}</Text>

        {data.map((item, index) => (
          <View key={index} style={styles.recordGroup}>

            <View style={styles.row}>
              <Text style={styles.label}>{t("managePayout.id")}:</Text>
              <Text style={styles.value}>{item.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("walletDetails.companyName")}:</Text>
              <Text style={styles.value}>{item.companyName}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("walletDetails.paypalBatchId")}:</Text>
              <Text style={styles.value}>{item.batchId}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("managePayout.payout_amount")}:</Text>
              <Text style={styles.value}>{item.payoutAmount}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("managePayout.method")}:</Text>
              <Text style={styles.value}>{item.method}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("managePayout.payment_date")}:</Text>
              <Text style={styles.value}>{item.paymentDate}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("managePayout.email")}:</Text>
              <Text style={styles.value}>{item.email}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("managePayout.status")}:</Text>
              <Text style={styles.value}>{item.status}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default MyWalletPDF;
